/** @jsx jsx */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import { Layout } from "../components/common";
import { MetaData } from "../components/common/meta";
import { LoadMore } from "../components/common/LoadMore";
import { css, jsx } from "@emotion/react";
import queryString from "query-string";
import { navigate } from "gatsby";
import { withPrefix } from "gatsby";
import { SearchInput } from "../components/common/utilities";
import SearchSection from "../components/common/search/SearchSection";

const DEFAULT_SHOW_POSTS = 8;

/**
 * Single page (/:slug)
 *
 * This file renders a single page and loads all the content.
 *
 */
class Page extends Component {
    constructor(props) {
        let params = queryString.parse(props.location.search);

        super(props);
        this.state = {
            showPosts: DEFAULT_SHOW_POSTS,
            showButton: true,
            filter: params.filter ? params.filter : "All",
            industry: params.industry ? params.industry : "All",
            industryF: "",
            country: params.series ? params.series : "All",
            countryF: "",
            productF: "",
            community: params.community ? params.community : "All",
            communityF: "",
            accordionInner: 0,
            isFilterOpen: true,
            search: params.query ? params.query : '',
            searchEnter: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.setIndustry = this.setIndustry.bind(this);
        this.setCountry = this.setCountry.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.setFilterF = this.setFilterF.bind(this);
        this.filterHandler = this.filterHandler.bind(this);

        this.dropdown = React.createRef();
        this.dropdown1 = React.createRef();
        this.dropdown2 = React.createRef();
        this.dropdown4 = React.createRef();
        this.dropdownBgLayer = React.createRef();

        this.accordion = React.createRef();
        this.searchInputRef = React.createRef();
    }

    handleClick() {
        this.setState({
            showPosts: this.state.showPosts + 4,
            showButton: true,
        });
    }

    updateQueryParms(param) {
        const query = queryString.parse(this.props.location.search);
        const searchParams = queryString.stringify({ ...query, ...param });
        navigate(`?${searchParams}`);
    }

    componentDidUpdate(prevProps, prevState) {
        const { filter, industry, country, search, searchEnter } = this.state;

        if (
            country !== prevState.country ||
            industry !== prevState.industry ||
            filter !== prevState.filter ||
            searchEnter!== prevState.searchEnter
        ) {
            const param = {};
            param.series = country;
            param.industry = industry;
            param.filter = filter;
            param.query = search;
            this.updateQueryParms(param);
            this.setState({searchEnter: false});
        }
        //to detect URL query params update
        if (this.props.location.search !== prevProps.location.search) {
            const query = queryString.parse(this.props.location.search);
            this.setState({search: query.query});
        }
    }

    setFilter(filter) {
        this.setState({
            filter,
            industry: "All",
            country: "All",
            productF: "",
        });

        if (this.dropdown1.current) {
            this.dropdown1.current.style.display = "none";
        }
        if (this.dropdownBgLayer.current) {
            this.dropdownBgLayer.current.style.display = "none";
        }
    }

    setIndustry(industry) {
        if (industry === this.state.industry) {
            this.setState({ industry, country: "All", industryF: "" });
        } else {
            this.setState({ industry, industryF: "" });
        }

        if (this.dropdown.current) {
            this.dropdown.current.style.display = "none";
        }
        if (this.dropdownBgLayer.current) {
            this.dropdownBgLayer.current.style.display = "none";
        }
    }

    setFilterF(name, value) {
        if (name === "search" && value) {
            this.setState({
                showPosts: DEFAULT_SHOW_POSTS,
                showButton: true,
            });
        }

        this.setState({ [name]: value });
    }

    setFilterV(name, value, dropdownRef) {
        this.setState({ [name]: value, [name+'F']:'' });
        dropdownRef.current.style.display = "none";
        if (this.dropdownBgLayer.current) {
            this.dropdownBgLayer.current.style.display = "none";
        }
    }

    setDropDown = (key, value) => {
        this.setState({ [key]: value });

        switch (key) {
            case "community":
                if (this.dropdown4.current) {
                    this.dropdown4.current.style.display = "none";
                }
                break;
            default:
        }
    };

    setCountry(country) {
        this.setState({ country, countryF: "" });

        if (this.dropdown2.current) {
            this.dropdown2.current.style.display = "none";
        }
    }

    getStyleList = () => {
        let list = [
            "Minimal",
            "Earthy",
            "Colourful",
            "Simple",
            "Patterns",
            "Geometric",
        ];
        return list;
    };
    getCommunityList = () => {
        let list = [
            "Eco Alliance",
            "Creatives",
            "Events",
            "Industry Experts",
            "itsnoissue",
        ];
        return list;
    };

    getTagName(tag) {
        if (tag === "KidsWear") {
            return "Kids Wear";
        }

        if (tag === "HomeandGift") {
            return "Home and Gift";
        }

        if (tag === "HealthandBeauty") {
            return "Health and Beauty";
        }
        return tag;
    }

    getProductName(product) {
        if (product === "noissueTissue") {
            return "noissue Tissue";
        }
        if (product === "noissueSticker") {
            return "noissue Stickers";
        }
        if (product === "noissueTape") {
            return "noissue Tape";
        }
        if (product === "noissueMailers") {
            return "noissue Mailers";
        }
        if (product === "noissueStamps") {
            return "noissue Stamps";
        }
        if (product === "noissueCards") {
            return "noissue Cards";
        }
        if (product === "noissueFoodsafe") {
            return "noissue Food Safe";
        }
        if (product === "noissueToteBags") {
            return "noissue Tote Bags";
        }
        if (product === "noissueKraftMailers") {
            return "noissue Kraft Mailers";
        }
        return product;
    }

    getProductTag() {
        let product = [
            "#noissueTissue",
            "#noissueSticker",
            "#noissueTape",
            "#noissueMailers",
            "#noissueStamps",
            "#noissueCards",
            "#noissueFoodsafe",
            "#noissueToteBags",
            "#noissueKraftMailers",
        ];
        return product;
    }
    getSeriesTag() {
        return [
            { tag: "nellie-recommends", displayName: "Nellie Recommends"},
            { tag: "inspiration-station", displayName:"Inspiration Station"},
            { tag: "packaging-anatomy", displayName: "Packaging Anatomy"},
            { tag: "marketingmasters", displayName: "Marketing Masters"},
            { tag: "building-a-brand", displayName: "Building A Brand"},
            { tag: "hash-creativebuzz", displayName: "Creative Buzz"},
            { tag: "conscious-commerce", displayName: "Conscious Commerce"},
            { tag: "noissue-eco-alliance", displayName: "Eco Alliance"},
            { tag: "hash-creativecommunity", displayName: "Creative Community"},
        ];
    }

    getCountryTag() {
        let country = [
            "Atlanta",
            "#AUSTRALIA",
            "Bangkok",
            "Brisbane",
            "Bristol",
            "#CANADA",
            "Dubai",
            "England",
            "#FINLAND",
            "#GERMANY",
            "#HONG KONG",
            "#ITALY",
            "#KOREA",
            "Los Angeles",
            "New York",
            "#NEW ZEALAND",
            "Seattle",
            "#SINGAPORE",
            "#SPAIN",
            "#THAILAND",
            "#UNITED ARAB EMIRATES",
            "#UNITED KINGDOM",
            "#UNITED STATES OF AMERICA",
            "USA",
            "California",
            "San Francisco",
            "New Jersey",
            "Melbourne",
            "#NORWAY",
            "Manchester",
            "#SWITZERLAND",
            "London",
            "#FRANCE",
            "Wales",
            "Sydney",
            "Brooklyn",
            "#PORTUGAL",
            "Vienna",
            "Austria",
            "Manila",
            "#PHILIPPINES",
            "BIPOC",
            "Portland",
            "Oregon",
            "Gerogia",
            "#JAPAN",
            "Asia",
            "Europe",
            "Vancouver",
            "North Carolina",
            "#Pottery",
            "Utah",
            "Pacific Islander",
            "#Malaysia",
            "Chicago",
            "Macrame",
            "Puerto Rico",
            "#Ireland",
            "Denmark",
            "#Netherlands",
            "#COLOMBIA",
            "Barcelona",
            "Iowa",
            "Auckland",
            "Argentina",
            "Dominican Republic",
            "Ohio",
            "Gold Coast",
            "New South Wales",
            "Poland",
            "Israel",
            "British Columbia",
            "Toronto",
            "miami",
            "Queensland",
            "Dublin",
            "Alberta",
            "Ontario",
            "Malta",
            "Victoria",
            "#CHILE",
            "Washington DC",
            "Cyprus",
            "Vermont",
            "northwales",
            "#Poshmark",
            "Florida",
            "Paris",
            "Wanaka",
            "San Diego",
            "Bogotá",
            "Wellington",
            "Oklahoma",
            "#INDONESIA",
            "Tokyo",
            "Berlin",
            "Bali",
            "#EGYPT",
        ];

        return country;
    }

    filterControl = (filterItem, filterName, page, id) => (
        <a
            href={withPrefix(`/${page.slug}?filter=${filterItem}`)}
            onClick={(e) => {
                e.preventDefault();
                this.setFilter(filterItem);
            }}
            key={id}
            className={`${this.state.filter === filterItem ? "active" : ""}`}
        >
            {filterName}
        </a>
    );

    getProductList = (tags) => {
        let list = [{ product: "#All", id: -1 }];
        tags.forEach((product, id) => {
            if (
                product.charAt(0) === "#" &&
                this.getProductTag().includes(product)
            ) {
                let temp = { product, id };
                list.push(temp);
            }
        });
        return list;
    };
    clearFilter = (name) => {};
    filters = (filtersList, page) =>
        filtersList.map((filter, id) =>
            filter === "noissue Stickers"
                ? this.filterControl("noissueSticker", filter, page, id)
                : filter === "Branding & Creative"
                ? this.filterControl("branding", filter, page, id)
                : this.filterControl(filter.replace(" ", ""), filter, page, id)
        );

    showHideDropDown = (dropdowns, current) => {
        if (current) {
            dropdowns.forEach((element) => {
                if (element !== current) element.current.style.display = "none";
            });
            current.current.style.display =
                current.current.style.display === "none" ? "block" : "none";
            this.dropdownBgLayer.current.style.display = "block";
        } else {
            dropdowns.forEach((element) => {
                element.current.style.display = "none";
            });
            this.dropdownBgLayer.current.style.display = "none";
        }
    };
    toggelAccordion = () => {
        if (!this.state.isFilterOpen) {
            this.accordion.current.style.maxHeight =
                this.accordion.current.scrollHeight + "px";
            this.accordion.current.style.overflow = "unset";
            this.accordion.current.style.opacity = 1;
        } else {
            this.accordion.current.style.maxHeight = 0;
            this.accordion.current.style.overflow = "hidden";
            this.accordion.current.style.opacity = 0;
        }

        this.setState({ isFilterOpen: !this.state.isFilterOpen });

        // setTimeout(()=>{
        //     this.accordion.current.style.display = this.accordion.current.style.display === 'none' ? 'block':'none';
        // },2000)
        // this.accordion.current.style.display = this.accordion.current.style.display === 'none' ? 'block':'none';
    };

    commonFilter(posts, searchParam){
        return posts.filter((post) => {
            if(post.node?.tags && searchParam!=='All'){
                let item = post.node.tags.find((tag) => {
                    let tName = tag.name.split(' ').join('').toLowerCase();
                    let tSeries = searchParam?.split(' ').join('').toLowerCase();
                    if(tName.includes(tSeries) )
                        return true;
                     }
                     )
                return !!item;
                }
            return true;
        });
    }

    searchFilter(array, { search, product, community, industry, series }) {
        let formatedList = array.filter(post=> !!post.node.excerpt);
        let filteredP = this.commonFilter(formatedList, product);
        let filteredC = this.commonFilter(filteredP, community);
        let filteredI = this.commonFilter(filteredC, industry);
        let filteredSr = this.commonFilter(filteredI, series);
        let filteredFi = filteredSr.filter((post)=>{
            if (
                post.node.title &&
                post.node.title
                    .toLocaleLowerCase()
                    .includes(search?.toLocaleLowerCase())
            )
                return true;
            if (
                post.node.plaintext &&
                post.node.plaintext
                    .toLocaleLowerCase()
                    .includes(search?.toLocaleLowerCase())
            )
                return true;
            if (
                post.node.excerpt &&
                post.node.excerpt
                    .toLocaleLowerCase()
                    .includes(search?.toLocaleLowerCase())
            )
                return true;
            if(post.node?.tags) {
                let item = post.node.tags.find((tag) => {
                        let tName = tag.name.split(' ').join('').toLowerCase();
                        let tSearch = search?.split(' ').join('').toLowerCase();
                        if(tName.includes(tSearch))
                            return true;
                        }
                        )
                    return !!item;
            }    
            return false;
        });
        return filteredFi;
    }

    filterHandler(value) {
        this.setState({search: value, searchEnter: true});
    }

    render() {
        const { data, location } = this.props;
        const {
            showPosts,
            filter,
            industry,
            country,
            community,
            communityF,
            isFilterOpen,
            search,
        } = this.state;
        const page = data.ghostPage;
        const posts = data.allGhostPost.edges;

        let tags = [];

        posts.forEach((post) => {
            const postTags = post.node.tags;

            if (postTags && postTags.length > 0) {
                const isPost = Object.keys(postTags).some(
                    (k) => postTags[k].slug === "hash-post"
                );

                if (isPost) {
                    postTags.forEach((tag) => {
                        if (tag.slug !== "hash-post") {
                            tags.push(tag.name);
                        }
                    });
                }
            }
        });

        tags = [...new Set(tags)];
        let productList = this.getProductList(tags);

        const filterData = this.searchFilter(posts, {
            search,
            product: filter,
            community,
            industry,
            series: country
        });
        let maxPosts = 4;
        const postLength = filterData.length;
        if (postLength < 10) maxPosts = 2;
        const hasMore = postLength > showPosts * maxPosts;
        const link = withPrefix(
            `/${page.slug}?filter=${filter}&industry=${industry}&series=${country}`
        );
        const link2 = withPrefix(
            `/${page.slug}?filter=${filter}&industry=${industry}&series=${country}`
        );
        const link3 = withPrefix(
            `/${page.slug}?filter=${filter}&industry=${industry}&series=${country}&community=${community}`
        );
        const link4 = withPrefix(
            `/${page.slug}?filter=${filter}&industry=${industry}&series=${country}&community=${community}`
        );
        const dropdowns = [
            this.dropdown,
            this.dropdown1,
            this.dropdown2,
            this.dropdown4,
        ];

        return (
            <>
                <div
                    ref={this.dropdownBgLayer}
                    className="dropdown-layer"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.showHideDropDown(dropdowns, null);
                    }}
                />
                <MetaData data={data} location={location} type="website" />
                <Layout bodyClass={`${page.slug} elbrus-headless`}>
                    <div className="container"
                        css={css`
                            margin-bottom: 5rem;
                        `}
                    >
                        <article className="content">
                            <h1
                                css={css`
                                    color: #fd566f;
                                    font-size: 6rem;
                                    text-align: center;
                                    line-height: 7rem;
                                    padding: 2rem;
                                    @media (max-width: 768px) {
                                        font-size: 3rem;
                                        line-height: 3rem;
                                    }
                                `}
                            >
                                Search The Wrap
                            </h1>
                            <section>
                                <div className="header-inspo">
                                    <div>
                                        <div className="accordion">
                                            <button
                                                className={`filter-by ${
                                                    !isFilterOpen
                                                        ? "filter-inverse"
                                                        : ""
                                                }`}
                                                onClick={() =>
                                                    this.toggelAccordion()
                                                }
                                            >
                                                <img
                                                    src="data:image/svg+xml;base64,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"
                                                    alt="filter"
                                                    className="filter-icon"
                                                />{" "}
                                                Filter By
                                            </button>
                                            <div className="search">
                                                <input
                                                    type="text"
                                                    placeholder="Search the Wrap..."
                                                    name="query"
                                                    value={search}
                                                    onChange={(e) => {
                                                        e.preventDefault();
                                                        this.setFilterF(
                                                            "search",
                                                            e.target.value
                                                        );
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            this.filterHandler(
                                                                e.target.value
                                                            );
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="filters  panel"
                                        ref={this.accordion}
                                    >
                                        <nav className="filter-controls filter-inspo">
                                            {page.slug === "biz-advice" ? (
                                                this.filters(
                                                    [
                                                        "Marketing",
                                                        "Branding & Creative",
                                                        "Sustainability",
                                                    ],
                                                    page
                                                )
                                            ) : (
                                                <div className="dropdown-wrapper">
                                                    <div className="dropdown-header">
                                                        <label className="dropdown-label">
                                                            Products
                                                        </label>
                                                        <span
                                                            className={`dropdown-clear ${
                                                                this.state
                                                                    .filter ===
                                                                "All"
                                                                    ? "hide"
                                                                    : ""
                                                            }`}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.setFilter(
                                                                    "All"
                                                                );
                                                            }}
                                                        >
                                                            Clear
                                                        </span>
                                                    </div>
                                                    <div className="has-dropdown">
                                                        <button
                                                            className="dropdown-button"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.showHideDropDown(
                                                                    dropdowns,
                                                                    this
                                                                        .dropdown1
                                                                );
                                                            }}
                                                        >
                                                            {this.getProductName(
                                                                filter
                                                            )}
                                                        </button>
                                                        <ul
                                                            className="dropdown"
                                                            ref={this.dropdown1}
                                                        >
                                                            <li key="0p">
                                                                <SearchInput
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .productF
                                                                    }
                                                                    setFilterF={
                                                                        this
                                                                            .setFilterF
                                                                    }
                                                                    valueKey="productF"
                                                                />
                                                            </li>
                                                            {productList
                                                                .filter(
                                                                    (item) =>
                                                                        item.product
                                                                            .toLocaleLowerCase()
                                                                            .includes(
                                                                                this.state.productF.toLocaleLowerCase()
                                                                            )
                                                                )
                                                                .map((item) => (
                                                                    <li
                                                                        key={
                                                                            item.id
                                                                        }
                                                                    >
                                                                        <a
                                                                            href={withPrefix(
                                                                                `/${
                                                                                    page.slug
                                                                                }?filter=${item.product.substr(
                                                                                    1
                                                                                )}`
                                                                            )}
                                                                            onClick={(
                                                                                e
                                                                            ) => {
                                                                                e.preventDefault();
                                                                                this.setFilter(
                                                                                    item.product.substr(
                                                                                        1
                                                                                    )
                                                                                );
                                                                            }}
                                                                            className={`${
                                                                                filter ===
                                                                                item.product.substr(
                                                                                    1
                                                                                )
                                                                                    ? "active"
                                                                                    : ""
                                                                            }`}
                                                                        >
                                                                            {this.getProductName(
                                                                                item.product.substr(
                                                                                    1
                                                                                )
                                                                            )}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="dropdown-wrapper">
                                                <div className="dropdown-header">
                                                    <label className="dropdown-label">
                                                        Community
                                                    </label>
                                                    <span
                                                        className={`dropdown-clear ${
                                                            community === "All"
                                                                ? "hide"
                                                                : ""
                                                        }`}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.setFilterF(
                                                                "communityF",
                                                                ""
                                                            );
                                                            this.setFilterV(
                                                                "community",
                                                                "All",
                                                                this.dropdown4
                                                            );
                                                        }}
                                                    >
                                                        Clear
                                                    </span>
                                                </div>
                                                <div className="has-dropdown">
                                                    <button
                                                        className="dropdown-button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            this.showHideDropDown(
                                                                dropdowns,
                                                                this.dropdown4
                                                            );
                                                        }}
                                                    >
                                                        {community}
                                                    </button>
                                                    <ul
                                                        className="dropdown"
                                                        ref={this.dropdown4}
                                                    >
                                                        <li key="0c">
                                                            <SearchInput
                                                                value={
                                                                    communityF
                                                                }
                                                                setFilterF={
                                                                    this
                                                                        .setFilterF
                                                                }
                                                                valueKey="communityF"
                                                            />
                                                        </li>
                                                        <li key="1c">
                                                            <a
                                                                href={link3}
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.preventDefault();
                                                                    this.setFilterV(
                                                                        "community",
                                                                        "All",
                                                                        this
                                                                            .dropdown4
                                                                    );
                                                                }}
                                                                className={`${
                                                                    communityF ===
                                                                    "All"
                                                                        ? "active"
                                                                        : ""
                                                                }`}
                                                            >
                                                                All
                                                            </a>
                                                        </li>
                                                        {this.getCommunityList()
                                                            .filter((item) =>
                                                                item
                                                                    .toLocaleLowerCase()
                                                                    .includes(
                                                                        communityF.toLocaleLowerCase()
                                                                    )
                                                            )
                                                            .sort(function (
                                                                a,
                                                                b
                                                            ) {
                                                                if (
                                                                    a.charAt(
                                                                        0
                                                                    ) === "#" &&
                                                                    b.charAt(
                                                                        0
                                                                    ) === "#"
                                                                ) {
                                                                    return a
                                                                        .substr(
                                                                            1
                                                                        )
                                                                        .toLowerCase()
                                                                        .localeCompare(
                                                                            b
                                                                                .substr(
                                                                                    1
                                                                                )
                                                                                .toLowerCase()
                                                                        );
                                                                }

                                                                if (
                                                                    a.charAt(
                                                                        0
                                                                    ) === "#" &&
                                                                    b.charAt(
                                                                        0
                                                                    ) !== "#"
                                                                ) {
                                                                    return a
                                                                        .substr(
                                                                            1
                                                                        )
                                                                        .toLowerCase()
                                                                        .localeCompare(
                                                                            b.toLowerCase()
                                                                        );
                                                                }

                                                                if (
                                                                    a.charAt(
                                                                        0
                                                                    ) !== "#" &&
                                                                    b.charAt(
                                                                        0
                                                                    ) === "#"
                                                                ) {
                                                                    return a
                                                                        .toLowerCase()
                                                                        .localeCompare(
                                                                            b
                                                                                .substr(
                                                                                    1
                                                                                )
                                                                                .toLowerCase()
                                                                        );
                                                                }

                                                                if (
                                                                    a.charAt(
                                                                        0
                                                                    ) !== "#" &&
                                                                    b.charAt(
                                                                        0
                                                                    ) !== "#"
                                                                ) {
                                                                    return a
                                                                        .toLowerCase()
                                                                        .localeCompare(
                                                                            b.toLowerCase()
                                                                        );
                                                                }
                                                                return 0;
                                                            })
                                                            .map((tag, id)=>(
                                                                        <li
                                                                            key={
                                                                                id
                                                                            }
                                                                        >
                                                                            <a
                                                                                href={`${link4}${tag.substr(
                                                                                    1
                                                                                )}`}
                                                                                onClick={(
                                                                                    e
                                                                                ) => {
                                                                                    e.preventDefault();
                                                                                    this.setFilterV(
                                                                                        "community",
                                                                                        tag.charAt(
                                                                                            0
                                                                                        ) ===
                                                                                            "#"
                                                                                            ? tag.substr(
                                                                                                  1
                                                                                              )
                                                                                            : tag,
                                                                                        this
                                                                                            .dropdown4
                                                                                    );
                                                                                }}
                                                                                className={`${
                                                                                    community === tag
                                                                                        ? "active"
                                                                                        : ""
                                                                                }`}
                                                                            >
                                                                                {tag}
                                                                            </a>
                                                                        </li>
                                                                    )
                                                            )}
                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="dropdown-wrapper">
                                                <div className="dropdown-header">
                                                    <label className="dropdown-label">
                                                        Industry
                                                    </label>
                                                    <span
                                                        className={`dropdown-clear ${
                                                            this.state
                                                                .industry ===
                                                            "All"
                                                                ? "hide"
                                                                : ""
                                                        }`}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.setIndustry(
                                                                "All"
                                                            );
                                                        }}
                                                    >
                                                        Clear
                                                    </span>
                                                </div>
                                                <div className="has-dropdown">
                                                    <button
                                                        className="dropdown-button"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            this.showHideDropDown(
                                                                dropdowns,
                                                                this.dropdown
                                                            );
                                                        }}
                                                    >
                                                        {this.state.industry}
                                                    </button>
                                                    <ul
                                                        className="dropdown"
                                                        ref={this.dropdown}
                                                    >
                                                        <li key="0b">
                                                            <SearchInput
                                                                value={
                                                                    this.state
                                                                        .industryF
                                                                }
                                                                setFilterF={
                                                                    this
                                                                        .setFilterF
                                                                }
                                                                valueKey="industryF"
                                                            />
                                                        </li>
                                                        <li key="1b">
                                                            <a
                                                                href={withPrefix(
                                                                    `/${page.slug}?filter=${filter}&industry=All`
                                                                )}
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.preventDefault();
                                                                    this.setFilterF(
                                                                        "industry",
                                                                        "All",
                                                                        this
                                                                            .dropdown
                                                                    );
                                                                }}
                                                                className={`${
                                                                    industry ===
                                                                    "All"
                                                                        ? "active"
                                                                        : ""
                                                                }`}
                                                            >
                                                                All
                                                            </a>
                                                        </li>
                                                        {tags
                                                            .filter((item) =>
                                                                item
                                                                    .toLocaleLowerCase()
                                                                    .includes(
                                                                        this.state.industryF.toLocaleLowerCase()
                                                                    )
                                                            )
                                                            .sort(function (
                                                                a,
                                                                b
                                                            ) {
                                                                if (
                                                                    a.charAt(
                                                                        0
                                                                    ) === "#" &&
                                                                    b.charAt(
                                                                        0
                                                                    ) === "#"
                                                                ) {
                                                                    return a
                                                                        .substr(
                                                                            1
                                                                        )
                                                                        .toLowerCase()
                                                                        .localeCompare(
                                                                            b
                                                                                .substr(
                                                                                    1
                                                                                )
                                                                                .toLowerCase()
                                                                        );
                                                                }
                                                                if (
                                                                    a.charAt(
                                                                        0
                                                                    ) === "#" &&
                                                                    b.charAt(
                                                                        0
                                                                    ) !== "#"
                                                                ) {
                                                                    return a
                                                                        .substr(
                                                                            1
                                                                        )
                                                                        .toLowerCase()
                                                                        .localeCompare(
                                                                            b.toLowerCase()
                                                                        );
                                                                }
                                                                if (
                                                                    a.charAt(
                                                                        0
                                                                    ) !== "#" &&
                                                                    b.charAt(
                                                                        0
                                                                    ) === "#"
                                                                ) {
                                                                    return a
                                                                        .toLowerCase()
                                                                        .localeCompare(
                                                                            b
                                                                                .substr(
                                                                                    1
                                                                                )
                                                                                .toLowerCase()
                                                                        );
                                                                }
                                                                if (
                                                                    a.charAt(
                                                                        0
                                                                    ) !== "#" &&
                                                                    b.charAt(
                                                                        0
                                                                    ) !== "#"
                                                                ) {
                                                                    return a
                                                                        .toLowerCase()
                                                                        .localeCompare(
                                                                            b.toLowerCase()
                                                                        );
                                                                }

                                                                return 0;
                                                            })
                                                            .map(
                                                                (tag, id) =>
                                                                    tag.charAt(
                                                                        0
                                                                    ) === "#" &&
                                                                    this.getProductTag().includes(
                                                                        tag
                                                                    ) !==
                                                                        true &&
                                                                    this.getCountryTag().includes(
                                                                        tag
                                                                    ) !==
                                                                        true && (
                                                                        <li
                                                                            key={
                                                                                id
                                                                            }
                                                                        >
                                                                            <a
                                                                                href={withPrefix(
                                                                                    `/${
                                                                                        page.slug
                                                                                    }?filter=${filter}&industry=${tag.substr(
                                                                                        1
                                                                                    )}`
                                                                                )}
                                                                                onClick={(
                                                                                    e
                                                                                ) => {
                                                                                    e.preventDefault();
                                                                                    this.setFilter(
                                                                                        filter
                                                                                    );
                                                                                    this.setIndustry(
                                                                                        tag.charAt(
                                                                                            0
                                                                                        ) ===
                                                                                            "#"
                                                                                            ? tag.substr(
                                                                                                  1
                                                                                              )
                                                                                            : tag
                                                                                    );
                                                                                }}
                                                                                className={`${
                                                                                    industry ===
                                                                                    (tag.charAt(
                                                                                        0
                                                                                    ) ===
                                                                                    "#"
                                                                                        ? tag.substr(
                                                                                              1
                                                                                          )
                                                                                        : tag)
                                                                                        ? "active"
                                                                                        : ""
                                                                                }`}
                                                                            >
                                                                                {this.getTagName(
                                                                                    tag.charAt(
                                                                                        0
                                                                                    ) ===
                                                                                        "#"
                                                                                        ? tag.substr(
                                                                                              1
                                                                                          )
                                                                                        : tag
                                                                                )
                                                                                    .split(
                                                                                        " "
                                                                                    )
                                                                                    .map(
                                                                                        (
                                                                                            w
                                                                                        ) =>
                                                                                            w[0].toUpperCase() +
                                                                                            w
                                                                                                .substr(
                                                                                                    1
                                                                                                )
                                                                                                .toLowerCase()
                                                                                    )
                                                                                    .join(
                                                                                        " "
                                                                                    )}
                                                                            </a>
                                                                        </li>
                                                                    )
                                                            )}
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="dropdown-wrapper">
                                                <div className="dropdown-header">
                                                    <label className="dropdown-label">
                                                        Series
                                                    </label>
                                                    <span
                                                        className={`dropdown-clear ${
                                                            this.state
                                                                .country ===
                                                            "All"
                                                                ? "hide"
                                                                : ""
                                                        }`}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.setCountry(
                                                                "All"
                                                            );
                                                        }}
                                                    >
                                                        Clear
                                                    </span>
                                                </div>
                                                <div className="has-dropdown">
                                                    <button
                                                        className="dropdown-button"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            this.showHideDropDown(
                                                                dropdowns,
                                                                this.dropdown2
                                                            );
                                                        }}
                                                    >
                                                        {this.state.country}
                                                    </button>
                                                    <ul
                                                        className="dropdown"
                                                        ref={this.dropdown2}
                                                    >
                                                        <li key="0cc">
                                                            <SearchInput
                                                                value={
                                                                    this.state
                                                                        .countryF
                                                                }
                                                                setFilterF={
                                                                    this
                                                                        .setFilterF
                                                                }
                                                                valueKey="countryF"
                                                            />
                                                        </li>
                                                        <li key="1c">
                                                            <a
                                                                href={withPrefix(
                                                                    `/${page.slug}?filter=${filter}&industry=${industry}&series=All`
                                                                )}
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.preventDefault();
                                                                    this.setFilterF(
                                                                        "country",
                                                                        "All",
                                                                        this
                                                                            .dropdown2
                                                                    );
                                                                }}
                                                                className={`${
                                                                    country ===
                                                                    "All"
                                                                        ? "active"
                                                                        : ""
                                                                }`}
                                                            >
                                                                All
                                                            </a>
                                                        </li>
                                                        {this.getSeriesTag()
                                                            .filter((item) =>
                                                                item.displayName
                                                                    .toLocaleLowerCase()
                                                                    .includes(
                                                                        this.state.countryF.toLocaleLowerCase()
                                                                    )
                                                            )
                                                            .map(
                                                                (
                                                                    seriesItem,
                                                                    id
                                                                ) => (
                                                                    <li
                                                                        key={id}
                                                                    >
                                                                        <a
                                                                            href={withPrefix(
                                                                                `/${page.slug}?filter=${filter}&industry=${industry}&series=${seriesItem.tag}`
                                                                            )}
                                                                            onClick={(
                                                                                e
                                                                            ) => {
                                                                                e.preventDefault();
                                                                                this.setFilter(
                                                                                    filter
                                                                                );
                                                                                this.setIndustry(
                                                                                    industry
                                                                                );
                                                                                this.setCountry(
                                                                                    seriesItem.displayName
                                                                                );
                                                                            }}
                                                                            className={`${
                                                                                country ===
                                                                                seriesItem.displayName
                                                                                    ? "active"
                                                                                    : ""
                                                                            }`}
                                                                        >
                                                                            {
                                                                                seriesItem.displayName
                                                                            }
                                                                        </a>
                                                                    </li>
                                                                )
                                                            )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </section>
                            <section
                                className="content-body load-external-scripts"
                                dangerouslySetInnerHTML={{
                                    __html: page.html,
                                }}
                            />
                            <SearchSection
                                data={postLength > 0 ? filterData : false}
                                showPosts={showPosts * maxPosts}
                                filters={{ query: search }}
                                filterHandler={this.filterHandler}
                            />
                        </article>
                    </div>
                    {hasMore && (
                        <div
                            css={css`
                                margin-bottom: 5rem;
                            `}
                        >
                            <LoadMore
                                items={postLength}
                                itemsViewed={showPosts * maxPosts}
                                handleClick={this.handleClick}
                            />
                        </div>
                    )}
                </Layout>
            </>
        );
    }
}

Page.propTypes = {
    data: PropTypes.shape({
        ghostPage: PropTypes.shape({
            codeinjection_styles: PropTypes.object,
            title: PropTypes.string.isRequired,
            feature_image: PropTypes.string,
        }).isRequired,
    }).isRequired,
    location: PropTypes.object.isRequired,
};

export default Page;

export const postQuery = graphql`
    query {
        ghostPage(slug: { eq: "search" }) {
            ...GhostPageFields
        }
        allGhostPost(
            sort: { order: DESC, fields: [published_at] }
            limit: 1000
            skip: 0
        ) {
            edges {
                node {
                    ...GhostPostFields
                }
            }
        }
    }
`;
